import wordings from './metrics-wording.json';
import { ForecastParamCode } from 'pleinchamp-api-client';

export type WordingObject = {
  titlePreferences: string;
  title: string;
  desc36h: string | null;
  desc15d: string | null;
  descHour: string | null;
  descPreferences: string | null;
};

export const metricsWording = (wordings as unknown) as Record<ForecastParamCode, WordingObject>;

export function getMetricWording(forecastParam: ForecastParamCode, type: MetricWordingType): string | null {
  return metricsWording[forecastParam][type];
}

export const orderedDefaultForecastParamCodes = [
  ForecastParamCode.WeatherCode,
  ForecastParamCode.AirTemperatureInCelsius,
  ForecastParamCode.AirTemperatureNearGroundInCelsius,
  ForecastParamCode.PrecipitationAmountInMillimeter,
  ForecastParamCode.MaxPrecipitationAmountInMillimeter,
  ForecastParamCode.PrecipitationProbabilityInPercent,
  ForecastParamCode.DominantWindDirection,
  ForecastParamCode.AverageWindSpeedInKilometerPerHour2,
  ForecastParamCode.MaxWindGustInKilometerPerHour2,
  ForecastParamCode.RelativeHumidityInPercent,
  ForecastParamCode.SaturationDeficitInHectoPascal,
  ForecastParamCode.DewPointTemperatureInCelsius,
  ForecastParamCode.EffectiveCloudCoverInPercent,
  ForecastParamCode.SunshineDurationInMinutes,
  ForecastParamCode.AirPressureAtSeaLevelInHectoPascal,
  ForecastParamCode.WindSpeedInKilometerPerHour,
  ForecastParamCode.FeelsLikeTemperatureInCelsius,
];

export const orderedDefaultForecastParamCodes15H = [
  ForecastParamCode.WeatherCode,
  ForecastParamCode.MinAirTemperatureNearGroundInCelsius,
  ForecastParamCode.MinAirTemperatureInCelsius,
  ForecastParamCode.MaxAirTemperatureInCelsius,
  ForecastParamCode.PrecipitationAmountInMillimeter,
  ForecastParamCode.MaxPrecipitationAmountInMillimeter,
  ForecastParamCode.PrecipitationProbabilityInPercent,
  ForecastParamCode.DominantWindDirection,
  ForecastParamCode.AverageWindSpeedInKilometerPerHour2,
  ForecastParamCode.MaxWindGustInKilometerPerHour2,
  ForecastParamCode.EvaporationMakkinkInMillimeter,
  ForecastParamCode.AverageRelativeHumidityInPercent,
  ForecastParamCode.SaturationDeficitInHectoPascal,
  ForecastParamCode.EffectiveCloudCoverInPercent,
  ForecastParamCode.SunshineDurationInHours,
  ForecastParamCode.GlobalRadiationInJoulePerSquareCentimeter,
  ForecastParamCode.UvIndexWithClouds,
  ForecastParamCode.GroundFrostProbabilityInPercent,
  ForecastParamCode.AverageAirPressureAtSeaLevelInHectoPascal,
  ForecastParamCode.AverageWindSpeedInKilometerPerHour10,
  ForecastParamCode.MaxWindGustInKilometerPerHour10,
  ForecastParamCode.Sunrise,
  ForecastParamCode.Sunset,
  ForecastParamCode.MoonPhase,
];

export const orderedDefaultForecastParamCodes36H = [
  ForecastParamCode.WeatherCode,
  ForecastParamCode.AirTemperatureInCelsius,
  ForecastParamCode.AirTemperatureNearGroundInCelsius,
  ForecastParamCode.MinAirTemperatureInCelsius,
  ForecastParamCode.MaxAirTemperatureInCelsius,
  ForecastParamCode.PrecipitationAmountInMillimeter,
  ForecastParamCode.MaxPrecipitationAmountInMillimeter,
  ForecastParamCode.PrecipitationProbabilityInPercent,
  ForecastParamCode.DominantWindDirection,
  ForecastParamCode.AverageWindSpeedInKilometerPerHour2,
  ForecastParamCode.MaxWindGustInKilometerPerHour2,
  ForecastParamCode.AverageRelativeHumidityInPercent,
  ForecastParamCode.SaturationDeficitInHectoPascal,
  ForecastParamCode.DewPointTemperatureInCelsius,
  ForecastParamCode.EffectiveCloudCoverInPercent,
  ForecastParamCode.AverageAirPressureAtSeaLevelInHectoPascal,
  ForecastParamCode.AverageWindSpeedInKilometerPerHour10,
  ForecastParamCode.MaxWindGustInKilometerPerHour10,
  ForecastParamCode.FeelsLikeTemperatureInCelsius,
];
